const moduleCreditsSel = (state: any) => state.credits;

export const paymentsSel = (state: any): any[] =>
  moduleCreditsSel(state).payments;
export const statusFilterSel = (state: any) =>
  moduleCreditsSel(state).statusFilter;
export const pageNumberSel = (state: any) => moduleCreditsSel(state).pageNumber;
export const pageSizeSel = (state: any) => moduleCreditsSel(state).pageSize;
export const totalElementsSel = (state: any) =>
  moduleCreditsSel(state).totalElements;
export const totalPagesSel = (state: any) => moduleCreditsSel(state).totalPages;

export const errorSel = (state: any) => moduleCreditsSel(state).error;
export const isPendingSel = (state: any) => moduleCreditsSel(state).isPending;
